import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { usePermissions } from "../../helper/PermissionContext";

// Each top-level menu group = one permission slug from the API.
// Sub-menu items are shown automatically when their parent group is visible.
const MENU = {
  dashboard: "dashboard",
  userManagement: "user-management",
  blogManagement: "blog-management",
  tmsIntegration: "tms-integration",
  caseStudy: "case-study",
  clientLogos: "client-logos",
  comparisonPage: "comparison-page",
  stats: "home-stats",
  seo: "global-seo",
  globalSeo: "global-seo",
  sitemap: "sitemap",
  mediaManagement: "media-management",
  llms: "llms-management",
  robots: "robots-management",
  logisticService: "logistic-service",
  featureService: "feature-service",
  dynamicPage: "dynamic-page",
  faq: "faq-management",
  contact: "contact-us",
  newsletter: "newsletter",
  emailManagement: "email-management",
  calculator: "calculator",
  pricing: "pricing",
  robotsManagement: "robots-management",
};

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [isCaseManagementOpen, setIsCaseManagementOpen] = useState(false);
  // const [isSeoManagementOpen, setIsSeoManagementOpen] = useState(false);
  const [isLogisticManagementOpen, setIsLogisticManagementOpen] = useState(false);
  const [isFeatureManagementOpen, setIsFeatureManagementOpen] = useState(false);
  const [isTmsIntegrationOpen, setIsTmsIntegrationOpen] = useState(false);
  const [isMediaManagementOpen, setIsMediaManagementOpen] = useState(false);
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);

  const { hasPermission } = usePermissions();

  const navigate = useNavigate();
  const toggleLogisticManagement = () => setIsLogisticManagementOpen((prev) => !prev);
  const toggleBlogManagement = () => setIsBlogManagementOpen((prev) => !prev);
  const toggleCaseManagement = () => setIsCaseManagementOpen((prev) => !prev);
  const toggleFeatureManagement = () => setIsFeatureManagementOpen((prev) => !prev);
  const toggleTmsIntegration = () => setIsTmsIntegrationOpen((prev) => !prev);
  const toggleMediaManagement = () => setIsMediaManagementOpen((prev) => !prev);
  const toggleUserManagement = () => setIsUserManagementOpen((prev) => !prev);
  // const toggleSeoManagement = () =>  setIsSeoManagementOpen((prev) => !prev);

  // const handleLogout = () => {
  //   localStorage.removeItem("AccessTokenTms");
  //   navigate("/login");
  // };

  const handleLogout = () => {
    localStorage.clear(); // 🔥 remove everything
    navigate("/login");
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/assets/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <div className="scroller-sidebar">
          <ul style={isOpen
            ? { transition: "all 0.3s ease-in", opacity: "0", visibility: "hidden" }
            : { transition: "all 0.3s ease-in", opacity: "1", visibility: "visible" }}>

            {hasPermission(MENU.dashboard) && (
              <li>
                <Link to="/"><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" />Dashboard</span></Link>
              </li>
            )}

            {hasPermission(MENU.userManagement) && (
              <li className={`innertab ${isUserManagementOpen ? "openlist" : ""}`} onClick={toggleUserManagement}>
                <div><span><img src="/assets/admin-user.webp" alt="icon" className="img-responsive" /> User Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isUserManagementOpen ? "open" : "close"}`}>
                  <li><Link to="users">Users</Link></li>
                  <li><Link to="roles">Roles</Link></li>
                  <li><Link to="permissions">Permissions</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.blogManagement) && (
              <li className={`innertab ${isBlogManagementOpen ? "openlist" : ""}`} onClick={toggleBlogManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Blog Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isBlogManagementOpen ? "open" : "close"}`}>
                  <li><Link to="blog">Blog</Link></li>
                  <li><Link to="category">Category</Link></li>
                  <li><Link to="author">Author</Link></li>
                  <li><Link to="tag">Tag</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.tmsIntegration) && (
              <li className={`innertab ${isTmsIntegrationOpen ? "openlist" : ""}`} onClick={toggleTmsIntegration}>
                <div><span><img src="/assets/dynamic-page.webp" alt="icon" className="img-responsive" /> TMS Integration</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isTmsIntegrationOpen ? "open" : "close"}`}>
                  <li><Link to="tms-integration">Integrations</Link></li>
                  <li><Link to="tms-integration-category">Category</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.caseStudy) && (
              <li className={`innertab ${isCaseManagementOpen ? "openlist" : ""}`} onClick={toggleCaseManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Case Study</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isCaseManagementOpen ? "open" : "close"}`}>
                  <li><Link to="/case-study">Case Studies</Link></li>
                  <li><Link to="/industry">Industry</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.clientLogos) && (
              <li>
                <Link to={"client-logos"}><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Client Logos</span></Link>
              </li>
            )}

            {hasPermission(MENU.comparisonPage) && (
              <li>
                <Link to={"comparison-page"}><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Comparison page</span></Link>
              </li>
            )}

            {hasPermission(MENU.stats) && (
              <li>
                <Link to={"/stats"}><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Home Stats</span></Link>
              </li>
            )}

            {hasPermission(MENU.seo) && (
              <li>
                <Link to={"seo"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> SEO Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.globalSeo) && (
              <li>
                <Link to={"global-seo"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Global SEO</span></Link>
              </li>
            )}

            {hasPermission(MENU.sitemap) && (
              <li>
                <Link to={"sitemap"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Sitemap</span></Link>
              </li>
            )}

            {hasPermission(MENU.mediaManagement) && (
              <li className={`innertab ${isMediaManagementOpen ? "openlist" : ""}`} onClick={toggleMediaManagement}>
                <div><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" /> Media Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isMediaManagementOpen ? "open" : "close"}`}>
                  <li><Link to="news">News</Link></li>
                  <li><Link to="news-category">Category</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.llms) && (
              <li>
                <Link to={"llms"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> LLMS Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.robotsManagement) && (
              <li>
                <Link to={"robots"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Robots.txt Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.logisticService) && (
              <li className={`innertab ${isLogisticManagementOpen ? "openlist" : ""}`} onClick={toggleLogisticManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Logistic Service</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isLogisticManagementOpen ? "open" : "close"}`}>
                  <li><Link to="logistic">Logistic Service </Link></li>
                  <li><Link to="logistic-category">Category</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.featureService) && (
              <li className={`innertab ${isFeatureManagementOpen ? "openlist" : ""}`} onClick={toggleFeatureManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Feature Service</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isFeatureManagementOpen ? "open" : "close"}`}>
                  <li><Link to="feature-category"> Feature Listing Page</Link></li>
                  <li><Link to="feature-service">Feature Details Page</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.dynamicPage) && (
              <li>
                <Link to={"dynamic"}><span><img src="/assets/dynamic-page.webp" alt="icon" className="img-responsive" /> Dynamic Page</span></Link>
              </li>
            )}

            {hasPermission(MENU.faq) && (
              <li>
                <Link to={"faq"}><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" /> FAQ Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.contact) && (
              <li>
                <Link to={"contact"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Contact Us</span></Link>
              </li>
            )}

            {/* {hasPermission(MENU.homeContact) && (
              <li>
                <Link to={"home-contact"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Home Contact</span></Link>
              </li>
            )} */}

            {hasPermission(MENU.newsletter) && (
              <li>
                <Link to={"newsletter"}><span><img src="/assets/newsletter.webp" alt="icon" className="img-responsive" /> Newsletter</span></Link>
              </li>
            )}

            {hasPermission(MENU.emailManagement) && (
              <li>
                <Link to={"email-management"}><span><img src="/assets/newsletter.webp" alt="icon" className="img-responsive" /> Email Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.calculator) && (
              <li>
                <Link to="calculator"><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" />  Calculator </span></Link>
              </li>
            )}

            {hasPermission(MENU.pricing) && (
              <li>
                <Link to="price"><span><img src="/assets/newsletter.webp" alt="icon" className="img-responsive" />  Pricing </span></Link>
              </li>
            )}

            {/* {hasPermission("career") && (
              <li>
                <Link to={"career"}><span><img src="/assets/career-icon.webp" alt="icon" className="img-responsive" /> Career</span></Link>
              </li>
            )} */}
          </ul>
        </div>

        <button onClick={handleLogout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
